<div>
    <InactivityModal />

    <!-- App shell: navbar + sidebar fixed; only content scrolls -->
    <div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

      <!-- Navbar -->
      <Navbar
        @sidebar-toggle="toggle_sidebar"
        class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
      </Navbar>

      
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area -->
      <div class="container-fluid flex-grow-1 overflow-hidden">
        <div class="row h-100">

          <!-- Sidebar column -->
          <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
            <div class="mt-2">
              <Sidebar ref="sidebar"></Sidebar>
            </div>
          </div>

          <!-- Content column -->
          <div class="col h-100 overflow-auto mt-2">
        <div class="card rounded-5 border-0">
              <div class="card-body mx-3 my-3 bg-white rounded-5">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>


              <div
                class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3"
                v-if="tabs.length > 0">
                <h5 class="fw-500 mb-0">Dynamic Profile Tabs</h5>
                <button class="btn btn-sm btn-primary text-xxs" @click="open_create_modal">
                  + Create Tab
                </button>
              </div>



                <!-- Tabs Table -->
                <div v-if="tabs.length" class="table-responsive">
                  <table class="table align-middle table-striped table-borderless mb-0">
                    <thead class="text-uppercase small btn-primary text-white text-xxs">
                      <tr>
                        <th class="text-center">#</th>
                        <th>Tab Name</th>
                        <th class="text-center">Locked?</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody class="text-xxs">
                      <tr v-for="(tab, index) in tabs" :key="tab.id" class="border-bottom">
                        <td class="text-center">
                          <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 small">
                            {{ index + 1 }}
                          </span>
                        </td>
                        <td>{{ tab.name }}</td>
                        <td class="text-center">
                          <span class="badge" :class="tab.is_locked ? 'bg-secondary' : 'bg-success'">
                            {{ tab.is_locked ? 'Locked' : 'Unlocked' }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="d-flex justify-content-center gap-1">
                            <router-link :to="'/create_form/' + tab.id">
                            <button class="btn btn-light btn-sm rounded text-success border text-xxs"
                                    >Manage Tabs</button>
                            </router-link>
                            <button class="btn btn-light btn-sm rounded text-success border text-xxs"
                                    @click="open_profile_types_modal(tab.id)">Assign Tab</button>
                            <button class="btn btn-light btn-sm rounded text-success border text-xxs"
                                    @click="create_tab(tab)">Edit</button>
                            <button class="btn btn-light btn-sm rounded text-danger border text-xxs"
                                    @click="delete_tabs(tab.id)">Delete</button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Empty State -->
                <div v-else class="text-center py-5">
                  <i class="bi bi-folder2-open display-1 text-muted mb-3"></i>
                  <p class="text-muted fs-5 mb-2">No tabs yet.</p>
                  <p class="text-muted text-xxs mb-3">Create tabs to organize profile information.</p>
                  <button class="btn btn-primary btn-sm text-xxs" @click="open_create_modal">
                    Create your first tab
                  </button>
                </div>

              </div>
            </div>
          </div>

        </div> <!-- /row -->
      </div> <!-- /container-fluid -->

    </div> <!-- /app shell -->

    <!-- Create/Edit Modal -->
    <div class="modal fade" id="tab_modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <h6 class="modal-title text-white">{{ editing_tab ? 'Edit Tab' : 'Create Tab' }}</h6>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <form @submit.prevent="editing_tab ? update_tab() : create_profile_tab()">
            <div class="modal-body">
                <div class="mb-3">
                <label class="form-label text-xxs fw-500">Tab Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control text-xxs rounded" v-model="tab_form.name">
                </div>

                <!-- Toggle switch -->
                <div class="form-check form-switch">
                <input class="form-check-input tab-lock" type="checkbox" id="is_locked" v-model="tab_form.is_locked">
                <label class="form-check-label text-xxs" for="is_locked">
                    Locked?
                </label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-sm btn-primary text-xxs">
                {{ editing_tab ? 'Update' : 'Save' }}
                </button>
            </div>
            </form>

            </div>
        </div>
        </div>

    <div class="modal fade" id="assignProfileTabs" tabindex="-1" aria-labelledby="assignProfileTabsLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <h5 v-if="is_unassigning" class="modal-title text-white text-xxs fw-500" id="assignProfileTabsLabel">
            Unassign Questions
          </h5>
          <h5 v-else class="modal-title text-white text-xxs fw-500" id="assignProfileTabsLabel">
            Assign/Unassign Profile Tab
          </h5>
          <!-- Close button on the end with white "X" -->
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
       <div class="modal-body">
        <p class="text-xxs">
          Select the profile types to assign the selected profile tab:
        </p>

        <div
          class="form-check form-check-sm text-xxs" v-for="profile in profile_types" :key="profile.id"
        >
          <input
            class="form-check-input"
            type="checkbox"  :id="'profile_' + profile.id":value="profile.id"v-model="selected_profile_types"
          />
          <label
            class="form-check-label text-xxs"
            :for="'profile_' + profile.id"
          >
            {{ profile.name }}
          </label>
        </div>
    </div>


  
        <div class="modal-footer">
          <button
            v-if="is_unassigning"
            type="button"
            class="btn btn-primary text-xxs rounded-5"
            @click="filter_assigned_questions"
          >
            Continue
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary text-xxs rounded-5"
            @click="assign_profile_tab"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>